module.exports = __webpack_public_path__ + "img/NHWBCarousel_parkDrinking.bc25fc50.webp";